// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3023) return "static/chunks/3023.65b52b5147b5aa73.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7699":"8e1d74a4","9212":"59650de3"}[chunkId] || chunkId) + "-" + {"2541":"5e27a424ca8ccfc3","7699":"558af8bf467b9d70","9212":"9c3f45a513fc42f7","9272":"0e127591c5165508"}[chunkId] + ".js";
};